import React from "react";
import H5 from "../components/Typography/H5";

export const _i = "07";

const NotFound: React.FC = (): React.ReactElement => {
  return (
    <div className="flex w-full h-screen">
      <H5>Page Not Found</H5>
    </div>
  );
};

export default NotFound;
